import { useLookupBlocsQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import BlocsItemComponent from "../../components/Blocs/BlocsItem";
function HomeRegister(){
    const {data,error,isLoading}=useLookupBlocsQuery({"r":{"clef":"welcome"}})
    const {translate}=useTrads();
  return (

    error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
    isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
    data && data.data.length > 0 &&
    <BlocsItemComponent bloc={data.data[0]}  />
    
  )
}
export default HomeRegister;